import type { VehicleVerificationSummary } from '@breaker/shared-types';
import { Badge } from '@/components/ui/badge';

function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

/**
 * The trust badge. Three states, same vocabulary as the shared derive helper:
 *   verified   -> "DVSA ✓ · expires 9 Mar 2027"  (green)
 *   failed     -> "Check failed"                  (red — the whole point)
 *   unverified -> "Unverified"                    (grey, honest default)
 */
export function VerificationBadge({
  verification,
  className,
}: {
  verification: VehicleVerificationSummary | undefined;
  className?: string | undefined;
}) {
  if (!verification || verification.status === 'unverified') {
    return (
      <Badge tone="neutral" className={className}>
        Unverified
      </Badge>
    );
  }
  if (verification.status === 'failed') {
    return (
      <Badge tone="danger" className={className}>
        Check failed
      </Badge>
    );
  }
  return (
    <Badge tone="success" className={className}>
      Gov ✓{verification.expiresAt ? ` · to ${shortDate(verification.expiresAt)}` : ''}
    </Badge>
  );
}
